import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FinancialService } from '../../../../core/services/financial.service';

/** XLSX fee-table importer for a single health plan — Angular port of
 *  FlutterFlow's ModalImportCSVHealthPlanWidget. Uploads to Storage then
 *  calls the same n8n webhook (procedures_to_health_plan RPC) the old app used. */
@Component({
  selector: 'app-import-health-plan-procedures-modal',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './import-health-plan-procedures-modal.component.html',
})
export class ImportHealthPlanProceduresModalComponent {
  @Input() branchId: number | null = null;
  @Input() healthPlanId: number | null = null;
  @Output() close = new EventEmitter<boolean>();

  loading = false;
  uploadSuccess = false;
  errorMessage: string | null = null;

  constructor(private financialService: FinancialService, private translate: TranslateService) {}

  onDragOver(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent) {
    event.preventDefault();
    event.stopPropagation();
    const files = event.dataTransfer?.files;
    if (files && files.length > 0) {
      this.handleFile(files[0]);
    }
  }

  onFileSelected(event: any) {
    const file = event.target.files[0];
    if (file) {
      this.handleFile(file);
    }
  }

  handleFile(file: File) {
    if (!this.branchId || !this.healthPlanId) {
      console.error('Missing branchId or healthPlanId');
      return;
    }

    this.loading = true;
    this.errorMessage = null;
    this.uploadSuccess = false;

    this.financialService.importHealthPlanProceduresXlsx(file, this.branchId, this.healthPlanId).subscribe({
      next: (result: any) => {
        if (result?.success) {
          this.uploadSuccess = true;
          setTimeout(() => this.close.emit(true), 2000);
        } else {
          this.errorMessage = result?.message || this.translate.instant('import_hp_process_failed');
          this.loading = false;
        }
      },
      error: (err) => {
        console.error('Import health plan procedures failed', err);
        this.errorMessage = err.message || this.translate.instant('import_hp_upload_failed');
        this.loading = false;
      },
    });
  }
}
